import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CompletionBarWithTitle } from 'modules/performance_process/components/common/CompletionBarWithTitle'
import ProcessTargetForPeerAssignmentDataTable from 'modules/performance_process/components/peerAssignments/ProcessTargetForPeerAssignmentDataTable'

interface Props {
  targetsForPeerAssignmentCount: number
  pendingTargetsForPeerAssignmentCount: number
  canAssign: boolean
}

export const PeerAssignment: React.FC<Props> = ({
  targetsForPeerAssignmentCount,
  pendingTargetsForPeerAssignmentCount,
  canAssign,
}) => {
  return (
    <Box gap="s32">
      <Box gap="s12">
        <Text size="500" weight="semibold" color="grey1000">
          {i18n.t('performance_process.reviews.peer_management.peer_assignments_title')}
        </Text>
        <Text.Normal>
          {i18n.t('performance_process.reviews.peer_management.peer_assignments_description')}
        </Text.Normal>
      </Box>

      <Box gap="s48">
        <CompletionBarWithTitle
          completed={targetsForPeerAssignmentCount - pendingTargetsForPeerAssignmentCount}
          total={targetsForPeerAssignmentCount}
        />

        <ProcessTargetForPeerAssignmentDataTable canAddPeers={canAssign} />
      </Box>
    </Box>
  )
}
